import React from "react";
import Link from "gatsby-link";
import { truncate } from "../../utils/helpers";
import styles from "./ArticleItem.module.scss";

class ArticleItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showAll: false
		};
	}

	handleTruncate = () => {
		const { showAll } = this.state;

		this.setState({ showAll: !showAll });
	};

	render() {
		const { showAll } = this.state;
		const { props } = this;

		return (
			<div className={styles.list_grid__item}>
				{props.cat_url ? (
					<Link
						to={props.cat_url}
						className={styles.list_grid__category}
					/>
				) : (
					<span className={styles.list_grid__category}>
						{props.category}
					</span>
				)}
				<h5>
					<a href={props.url} target="_blank" className="list_props_grid__link">
						{props.title}
					</a>
				</h5>
				<span className={styles.list_grid__excerpt}>
					{props.excerpt &&
						(!showAll
							? truncate(props.excerpt, 120, true)
							: props.excerpt)}{" "}
					{props.excerpt &&
						props.excerpt.length > 120 && (
							<button
								onClick={() => this.handleTruncate()}
								className={styles.show_more}
							>
								{!showAll ? "show more ▾" : "« show less"} 
							</button>
						)}
				</span>
				<span className={styles.list_grid__info}>
					{/* <span className={styles.author}>{props.author}</span> */}
					{/* <span className={styles.divider}>|</span> */}
					
					{props.pub_details && (
						<span className={styles.date}><span style={{fontWeight: "bold"}}>{props.pub_details}</span>, {props.published_date}</span>
					)}
				</span>
			</div>
		);
	}
}

export default ArticleItem;



// WEBPACK FOOTER //
// ./src/components/ArticleItem/index.js